export default __webpack_public_path__ + "static/media/bricks_responsive.c8cc431d.png";